module.exports = __webpack_public_path__ + "img/swiper_07.8d5c5722.jpg";